import api from './api';
import ImportSpreadsheetDataService from './ImportSpreadsheetDataService';

const BASE_URL = '/purchases';

class PurchasesService {
  constructor() {
    this.httpClient = api;
  }

  mappedJsonData(payload) {
    return payload.map((item) => ({
      item: item.Item,
      quantidade: item.Quantidade,
      preco_unit: item['Preço unitário'],
      unidade: item.Unidade,
      total: item.Total,
      pagamento: item.Pagamento,
      total_conta: item['Valor total da conta'],
      forma_pagamento: item['Forma de pagamento'],
      conta: item.Conta,
      quantidade_parcelas: item['Quantidade de parcelas'],
      valor_parcela: item['Valor da parcela'],
      vencimento: item.Vencimento,
    }));
  }

  async purchaseList() {
    const response = await (await api.get(`${BASE_URL}`)).data;
    return response;
  }

  async purchaseListExport() {
    const response = await (await api.get(`${BASE_URL}/export`)).data;
    return response;
  }

  async importData(payload) {
    return ImportSpreadsheetDataService.importData(payload, BASE_URL, this.mappedJsonData);
  }
}

export default new PurchasesService();
